module.exports = __webpack_public_path__ + "fonts/MessinaSansWeb-Black.4341654c.woff";